<template>

      <ChatBody ref="chat" :width="width" :height="height" :error="error">

        <template #messages>
          <ChatMessage v-for="(p, index) in messages" :key="p.id || index" :chatuser="user" :item="p" @reply="reply(p)" @delete="deleteMessage(p)"/>
        </template>

        <template #files>
          <ChatFile v-for="(ff, findex) in files" :file="ff" :key="fileKey(ff, findex)" @delete="removeFile(ff)" @click.prevent="showfile(ff)"/>
        </template>

        <template #reply>
          <ChatReply v-if="quote && quote.id" :name="quote.name" :text="quote.text" @delete="deleteReply()"/>
        </template>

        <template #input>
          <ChatInput ref="input" v-model="message.text" @send="send()">
            <template #left>
              <ChatIconUpload v-upload="appendFiles"/>
              <Switch v-model="sendAsUser" title="Send as user (ex: tests, etc)"/>
            </template>
            <template #right><ChatIconSend :style="{opacity: progress ? .35 : 1}" @click="send()"/></template>
          </ChatInput>
        </template>
      </ChatBody>

    <!-- asset preview -->
    <Teleport to="body">
      <Popup v-model="showFilePopup">
        <template #icon>
          <img style="max-height: 34px; width: auto;" :src="fileIcon">
        </template>
        <template #title>Attachment</template>
        <div class="column w400 left" style="padding: 20px 30px;">
          <p>{{ fileName }}</p>
        </div>
      </Popup>
    </Teleport>


</template>
<script setup>
import ChatBody from './ChatBody.vue';
import ChatFile from './ChatFile.vue';
import ChatIconSend from './ChatIconSend.vue';
import ChatIconUpload from './ChatIconUpload.vue';
import ChatInput from './ChatInput.vue';
import ChatMessage from './ChatMessage.vue';
import ChatReply from './ChatReply.vue';
</script>
<script>
/* eslint-disable */
import { defineComponent } from 'vue';
// https://github.com/fritx/vue-at/tree/vue3#readme
export default defineComponent({
  mounted() {
      this.initChat()
      this.getChat()
  },
  beforeUnmount() {
      this.unsubscribe()
  },
  props:{
    id: [Number, String], //chat id (int64 on the API side, may come as a string)
    width: {type:String, default:'380px'},
    height: {type:String, default:'90vh'},
  },

  data() {
    return {
      // asset: undefined, //uid/chat id
      chat:{},
      showFilePopup: false,
      showMentionsPopup: false,

      files:[],
      file: undefined,
      quote: {},

      message:{
        chat: this.id,
        text: undefined,
        reply: undefined,
        call: [],
        files: [],
    	},


      progress: false,
      done: true,
      error: undefined,

      items: [],
      readMessages: [],
      unsubscribeChat: undefined,

      sendAsUser: false,

    }
  },
  watch: {
    id() {
      this.reloadChat()
    },
    messages: {
      handler(list) {
        this.markMessagesRead(list)
      },
      immediate: true,
    },
  },
  computed: {
    messages(){
      let list = Array.isArray(this.items) ? [...this.items] : []
      if (!list.length) return []
      return list.sort((a,b) => this.messageSortValue(b) - this.messageSortValue(a))
    },

    // chat owner: "send as user" must never fall back to the last author, it may be an admin
    user(){
      return this.chat && this.chat.uid ? this.chat.uid : 0
    },
    fileName(){
      return this.file && this.file.name ? this.file.name : ''
    },
    fileIcon(){
      let name = this.fileName || (this.file && this.file.link) || 'txt'
      let ext = (this.tools.ext(name) || 'txt').toUpperCase()
      return `/images/icons/file/${ext}.svg`
    },

    // teamlist(){
    //   let team = this.db.supportTeam
    //   if (!team || !team.length) return []
    //   let list = []
    //   team.forEach(p => {
    //       list.push({id: p.id, name: p.name || 'no name', email: p.email, dept: p.dept})
    //   });
    //   return list
    // },
  },

  methods: {

    async reloadChat(){
      this.unsubscribe()
      this.items = []
      this.chat = {}
      this.sendAsUser = false
      this.readMessages = []
      this.resetMessage()
      this.quote = {}
      this.files = []
      await this.initChat()
      await this.getChat()
    },

    async initChat(){
      console.log('init chat', this.id)
      let id = this.id
      if (!id) return

      this.error = undefined
      let items = await this.chats.get(id, 50, 0)
      this.items = Array.isArray(items) ? items : []
      this.subscribe()

    },

    async getChat(){
      console.log('get chat', this.id)
      let id = this.id
      if (!id) return

      this.chat = await this.chats.chat(id)
      console.log('chat', this.chat)
    },

    resetMessage(){
      console.log('reset message')
      this.message = {
        chat: this.id,
        text: undefined,
        reply: undefined,
        call: [],
        files: [],
    	}
    },

    subscribe(){
      let chat = this.id
      this.unsubscribe()
      this.unsubscribeChat = this.chats.subscribeChat(chat, this.inbox, this.removeMessage)
      console.log("chat subscribe", chat)
    },

    unsubscribe(){
      if (typeof this.unsubscribeChat != 'function') return
      this.unsubscribeChat()
      this.unsubscribeChat = undefined
    },

    inbox(data){
      console.log("inbox:",data)
      if (!data) return
      let index = this.items.findIndex(p => p.id && data.id && p.id == data.id)
      if (index > -1) {
        this.items.splice(index, 1, data)
      } else {
        this.items.push(data)
      }
      if (data.team) {
        this.$emit('message', true)
      }
      this.$nextTick(this.scrollToBottomChat)
    },


    async send(){
      if (this.progress) return

      let user = this.sendAsUser ? this.user : 0
      if (this.sendAsUser && !user) {
        this.error = 'Chat user is not loaded'
        return
      }
      let chat = this.id
      let text = (this.message.text || '').trim()
      let osfiles = Array.isArray(this.files) ? this.files : []
      if (!chat || (!text && !osfiles.length)) return

      this.progress = true
      this.error = undefined

      try {
        let reply = this.quote && this.quote.id ? this.quote.id : 0
        let res = await this.chats.send(chat, text, osfiles, reply, user)
        if (!res || res.error) {
          let error = res && res.error ? res.error : 'Message was not sent'
          this.error = error
          alert(error)
          console.error(error)
          return
        }

        this.files = []
        this.quote = {}
        this.resetMessage()
        this.resetTextarea()
        this.$nextTick(this.scrollToBottomChat)
      } catch (error) {
        this.error = error && error.message ? error.message : 'Message was not sent'
        console.error(error)
      } finally {
        this.progress = false
      }
    },


    // reset textarea
    resetTextarea(){
      let input = this.$refs.input
      if (!input || typeof input.resetArea != 'function') return
      input.resetArea()
    },

    appendFiles(files){
      console.log('new files', files)
      let list = Array.from(files || [])
      if (!list.length) return
      this.files = this.files.concat(list)
    },

    removeFile(file){
      let index = this.files.indexOf(file)
      if (index > -1) this.files.splice(index, 1)
    },

    fileKey(file, index){
      if (!file) return index
      return `${file.name || 'file'}-${file.size || 0}-${file.lastModified || index}`
    },


    showfile(file){
      this.file = file
      this.showFilePopup = true
    },

    async changeStatus(id, status){
      let res = await this.api.send('support/update/asset/status', {id, status})
      if (res.error) return
      this.refreshAssets()
    },

    async refreshAssets(){
      let user = this.id
      let res = await this.api.send('support/assets', {user})
      if (res.error) return
      this.assets = res.resp.assets || []
    },

    mention(team){
      console.log('team', team)
      this.message.mention = team.id
      this.message.private = true
    },

    checkEmptyArea(){
      if (!this.message.text) {
        this.message.mention = undefined
        this.message.private = undefined
      }
    },


    ctrlclick(message){
      console.log('ctrlclick',message)
    },

    async deleteMessage(message){
      if (!message || !message.id) return
      let res = await this.chats.delete(message.id)
      if (!res || res.error) {
        this.error = res && res.error ? res.error : 'Message was not deleted'
        return
      }
      this.removeMessage(message.id)
    },

    // ws сообщает об удалении и другим админам, и юзеру
    removeMessage(id){
      this.items = this.items.filter(p => p.id != id)
      if (this.quote && this.quote.id == id) this.quote = {}
    },

    reply(msg){
      let p = this.tools.clone(msg)
      p.quote = undefined
      this.quote = p
    },

    deleteReply(){
      this.quote = {}
    },

    at(anchorLink) {
        let el = this.$refs[anchorLink]
        el.scrollIntoView({ behavior: 'smooth'})
    },

    scrollToMessage(id) {
      console.log('scrollToMessage', id)
        let el = this.$refs[`msg${id}`]
        el.scrollIntoView()
    },

    scrollToBottomChat() {
        let el = this.$refs.chat
        if (el && typeof el.scrollToBottom == 'function') return el.scrollToBottom()
    },

    messageSortValue(message){
      if (!message) return 0
      return Number(message.id || message.created || 0)
    },

    markMessagesRead(list){
      if (!Array.isArray(list) || !list.length) return
      let read = []
      list.forEach(p => {
        if (!p || p.read || p.team || !p.id) return
        if (this.readMessages.indexOf(p.id) > -1) return
        this.readMessages.push(p.id)
        read.push(p.id)
      });
      if (read.length) this.chats.read(read)
    },


  },
});

</script>
<style scoped>
</style>
